import { tw } from '~/utils';

export const pageTitleStyles = tw('text-headline-s md:text-headline-xl mb-6 md:mb-12');
